import { defineEvent } from '../types/event';
export var PDP_COLOR_SWATCH_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_PDP_Colors_Swatches'
        }
    ]
});
